import { render } from "./CertificateForm.vue?vue&type=template&id=71b2142b&scoped=true"
import script from "./CertificateForm.vue?vue&type=script&lang=js"
export * from "./CertificateForm.vue?vue&type=script&lang=js"

import "./CertificateForm.vue?vue&type=style&index=0&id=71b2142b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b2142b"]])

export default __exports__